import { render, staticRenderFns } from "./ListPages.vue?vue&type=template&id=3930d0aa&scoped=true&"
import script from "./ListPages.vue?vue&type=script&lang=js&"
export * from "./ListPages.vue?vue&type=script&lang=js&"
import style0 from "./ListPages.vue?vue&type=style&index=0&id=3930d0aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930d0aa",
  null
  
)

export default component.exports